import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, ModalController, ViewController, 
AlertController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app/app-config';
import { UserserviceProvider } from '../../providers/userservice';
import { VerglasungPage } from './verglasung/verglasung';


@Component({
  selector: 'page-sprossentype',
  templateUrl: 'sprossentype.html',
})
export class SprossentypePage {
sprossen: any;
sprossen1: any;
sprossen2: any;
sprossen3: any;
selectedSprossentyp: any;
selectedSprossenfarbe: any;
selectedSprossenmuster: any;
sprossen_cat: any; 
sprossen_img: any;
filter: false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient, public appConfig: AppConfig, public userService: UserserviceProvider, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public viewCtrl : ViewController, public alertCtrl: AlertController ) {
  
    this.sprossen_cat = this.navParams.get('sprossen_cat');
    this.selectedSprossentyp = this.navParams.get('selectedSprossentyp');
    this.selectedSprossenmuster = this.navParams.get('selectedSprossenmuster');
    this.selectedSprossenfarbe = this.navParams.get('selectedSprossenfarbe');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SprossentypePage');
  }
    
  selectedSprossen(sprosse){
  if (this.sprossen_cat == "sprossentyp") {
   this.selectedSprossentyp = sprosse;
  } if (this.sprossen_cat == "sprossen_farbe") {
    this.selectedSprossenfarbe = sprosse;
  } if (this.sprossen_cat == "sprossen_muster") {
    this.selectedSprossenmuster = sprosse;
  }
    this.viewCtrl.dismiss({ sprossen1: this.selectedSprossentyp, sprossen2: this.selectedSprossenfarbe, sprossen3: this.selectedSprossenmuster });
    }

    closeModal(){
    this.viewCtrl.dismiss({ sprossen1: this.selectedSprossentyp, sprossen2: this.selectedSprossenfarbe, sprossen3: this.selectedSprossenmuster });
} 

      ionViewWillEnter() : void
   {
    this.getSprossen();
   }
   
   
  getSprossen(){
  this.presentLoading();
  this.userService.getSprossen(this.sprossen_cat)
  .subscribe((data : any) =>
      { 
          this.sprossen = data;
          console.dir(data);
          this.loading.dismiss();
      },
      (error : any) =>
      {
         console.dir(error);
        this.loading.dismiss();
      });    
        }
        
     presentLoading() {
        this.loading = this.loadingCtrl.create({
        content: 'Please wait...'
        });
        this.loading.present();
    }
   
   
   doRefresh(refresher) {
   this.getSprossen();
   refresher.complete();
   }
        

}




// WEBPACK FOOTER //
// ./src/pages/sprossentype/sprossentype.ts